import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Search, ChevronDown } from "lucide-react";
import { frApi, errMsg, cardCls, fieldCls } from "./frUtils";
import RecordCard from "./RecordCard";

const FILTERS = [["", "All"], ["pending", "Approval pending"], ["open", "Open"], ["converted", "Converted"], ["lost", "Lost"]];

export default function HistoryTab({ isMgmt }) {
    const [status, setStatus] = useState("");
    const [q, setQ] = useState("");
    const [items, setItems] = useState(null);
    const [limit, setLimit] = useState(50);
    const load = useCallback(() => frApi.get("/records", { status, q, limit }).then((d) => setItems(d.items)).catch((e) => { toast.error(errMsg(e)); setItems([]); }), [status, q, limit]);
    useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
    const matches = (rec) => !status || rec.approval_status === status || rec.conversion_status === status;
    const replace = (rec) => setItems((xs) => xs.map((x) => (x.id === rec.id ? rec : x)).filter(matches));

    return (
        <div className="space-y-4" data-testid="fr-history">
            <div className={`${cardCls} space-y-3`}>
                <div className="relative">
                    <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                    <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search parent, student, phone, city or subject" className={`${fieldCls} pl-9`} data-testid="fr-history-search" />
                </div>
                <div className="flex flex-wrap gap-2">
                    {FILTERS.map(([v, l]) => (
                        <button key={v || "all"} type="button" onClick={() => setStatus(v)} data-testid={`fr-history-filter-${v || "all"}`}
                            className={`h-9 px-3 rounded-full text-xs font-semibold border ${status === v ? "bg-[#0F172A] text-white border-[#0F172A]" : "bg-white text-slate-700 border-slate-200"}`}>{l}</button>
                    ))}
                </div>
            </div>
            {items === null ? <div className="grid place-items-center p-8"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div>
                : items.length === 0 ? <div className={`${cardCls} text-sm text-slate-500 text-center`} data-testid="fr-history-empty">No fee records yet.</div>
                    : items.map((rec) => <RecordCard key={rec.id} rec={rec} isMgmt={isMgmt} onChange={replace} />)}
            {items && items.length >= limit && (
                <button type="button" onClick={() => setLimit((l) => l + 50)} className="w-full h-10 text-sm font-semibold text-[#1E3A8A] inline-flex items-center justify-center gap-1" data-testid="fr-history-more">
                    <ChevronDown className="w-4 h-4" /> Show more
                </button>
            )}
        </div>
    );
}
